import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, PageEvent } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { ComentarioDialogComponent } from '../comentario-dialog/comentario-dialog.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-bitacora-dialog',
  templateUrl: './bitacora-dialog.component.html',
  styleUrls: ['./bitacora-dialog.component.scss']
})
export class BitacoraDialogComponent implements OnInit {

  cita: any;
  idcita: number;
  loading: boolean = false;
  loadingCita: boolean = false;
  tabActual: number = 0;

  // Mapa de colores por tipo - agregar nuevos tipos aqui
  tipoColores: { [key: string]: string } = {
    'Gestion': '#1565c0',
    'Plantilla': '#2e7d32',
    'Cita': '#e65100',
    'Comentario': '#4a148c',
    'Liberar': '#9c27b0',
  };
  tipoColorDefault: string = '#757575';

  // Tab 1: Bitacora de la cita (SP nuevo)
  displayedColumnsCita: string[] = [
    'orden', 'tipo_orden', 'fecha_cita', 'locacion', 'tecnico', 'tel_tecnico',
    'supervisor', 'tel_supervisor', 'contrata', 'hora_salida', 'hora_sitio',
    'hora_finaliza', 'tiempo_en_sitio', 'fecha_llamada', 'tipo_contacto',
    'motivo', 'resultado', 'estado_orden', 'tipologia', 'subtipologia',
    'observaciones', 'nombre_usuario'
  ];
  dataSourceCita = new MatTableDataSource<any>([]);
  totalRegistrosCita: number = 0;
  paginaActualCita: number = 1;

  // Tab 2: Historico cliente (SP viejo)
  displayedColumns: string[] = [
    'tipo', 'orden', 'tipologia', 'subtipologia', 'fecha',
    'fecha_visita', 'am_pm', 'hora_puntual', 'estado', 'comentario', 'contrata',
    'tecnico', 'usuario', 'prioridad', 'direccion', 'localizacion'
  ];
  dataSource = new MatTableDataSource<any>([]);
  totalRegistros: number = 0;
  paginaActual: number = 1;
  pageSize: number = 10;

  @ViewChild('paginatorCita') paginatorCita: MatPaginator;
  @ViewChild('paginatorHistorico') paginatorHistorico: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<BitacoraDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService,
    private dialog: MatDialog
  ) {
    this.cita = data.cita;
    this.idcita = data.cita.idcita || data.cita.id;
  }

  ngOnInit() {
    this.cargarBitacoraCita(1);
  }

  onTabChange(index: number): void {
    this.tabActual = index;
    if (index === 0 && this.dataSourceCita.data.length === 0) {
      this.cargarBitacoraCita(1);
    } else if (index === 1 && this.dataSource.data.length === 0) {
      this.cargarHistorico(1);
    }
  }

  // Tab 1: Bitacora de la cita
  cargarBitacoraCita(pagina: number): void {
    this.loadingCita = true;
    this.paginaActualCita = pagina;
    this.gateway.get('obtenerbitacoracita', {
      IDCITA: this.idcita,
      PAGINA: pagina,
      TAMANO: this.pageSize
    }).then((res: any) => {
      this.dataSourceCita.data = res.rows || [];
      this.totalRegistrosCita = res.total || 0;
      this.loadingCita = false;
    }).catch(() => {
      this.loadingCita = false;
    });
  }

  onPageChangeCita(event: PageEvent): void {
    this.cargarBitacoraCita(event.pageIndex + 1);
  }

  // Tab 2: Historico cliente
  cargarHistorico(pagina: number): void {
    this.loading = true;
    this.paginaActual = pagina;
    this.gateway.get('obtenerbitacora', {
      IDCITA: this.idcita,
      PAGINA: pagina
    }).then((res: any) => {
      this.dataSource.data = res.rows || [];
      this.totalRegistros = res.total || 0;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  }

  onPageChange(event: PageEvent): void {
    this.cargarHistorico(event.pageIndex + 1);
  }

  getBadgeColor(tipo: string): string {
    return this.tipoColores[tipo] || this.tipoColorDefault;
  }

  abrirComentarioDialog(): void {
    const dialogRef = this.dialog.open(ComentarioDialogComponent, {
      width: '500px',
      panelClass: 'bitacora-dialog-panel',
      disableClose: true,
      data: { idcita: this.idcita }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cargarBitacoraCita(1);
      }
    });
  }

  /**
   * Resalta en negrita el separador "->" que el SP usa para los cambios
   * (formato "valor anterior -> valor nuevo", p.ej. en Técnico de las filas
   * tipo "Cambio"). Escapa primero el HTML del texto para evitar XSS y solo
   * inyecta el <strong> sobre la flecha. Se usa con [innerHTML].
   */
  resaltarFlecha(value: any): string {
    if (value == null || value === '') { return ''; }
    const esc = String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    return esc.replace(/-&gt;/g, '<strong>-&gt;</strong>');
  }

  formatFecha(fecha: any): string {
    if (!fecha) return '';
    const str = String(fecha);
    if (str.indexOf('->') > -1) return str;
    const d = new Date(str);
    if (isNaN(d.getTime())) return str;
    const dd = ('0' + d.getDate()).slice(-2);
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const yyyy = d.getFullYear();
    const hh = ('0' + d.getHours()).slice(-2);
    const min = ('0' + d.getMinutes()).slice(-2);
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
  }

  descargar(): void {
    if (this.tabActual === 0) {
      this.descargarBitacoraCita();
    } else {
      this.descargarHistorico();
    }
  }

  descargarBitacoraCita(): void {
    const totalPaginas = Math.ceil(this.totalRegistrosCita / this.pageSize) || 1;
    const promesas = [];
    for (let i = 1; i <= totalPaginas; i++) {
      promesas.push(this.gateway.get('obtenerbitacoracita', {
        IDCITA: this.idcita, PAGINA: i, TAMANO: this.pageSize
      }));
    }
    Promise.all(promesas).then((resultados: any[]) => {
      let todos = [];
      resultados.forEach(res => { if (res.rows) todos = todos.concat(res.rows); });
      const data = todos.map(r => ({
        'Orden': r.orden || '', 'Tipo Orden': r.tipo_orden || '', 'Fecha Cita': r.fecha_cita || '',
        'Locación': r.locacion || '', 'Técnico': r.tecnico || '', 'Tel. Técnico': r.tel_tecnico || '',
        'Supervisor': r.supervisor || '', 'Tel. Supervisor': r.tel_supervisor || '',
        'Contrata': r.contrata || '', 'Hora Salida': this.formatFecha(r.hora_salida),
        'Hora Sitio': this.formatFecha(r.hora_sitio), 'Hora Finaliza': this.formatFecha(r.hora_finaliza),
        'Tiempo en Sitio (min)': r.tiempo_en_sitio || 0, 'Fecha Llamada': this.formatFecha(r.fecha_llamada),
        'Tipo Contacto': r.tipo_contacto || '', 'Motivo': r.motivo || '', 'Resultado': r.resultado || '',
        'Estado Orden': r.estado_orden || '', 'Tipología': r.tipologia || '', 'Subtipología': r.subtipologia || '',
        'Observaciones': r.observaciones || '', 'Usuario': r.nombre_usuario || ''
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Bitácora');
      const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const orden = todos.length > 0 ? todos[0].orden || '' : '';
      saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Bitacora_${orden}.xlsx`);
    });
  }

  descargarHistorico(): void {
    const totalPaginas = Math.ceil(this.totalRegistros / this.pageSize) || 1;
    const promesas = [];
    for (let i = 1; i <= totalPaginas; i++) {
      promesas.push(this.gateway.get('obtenerbitacora', { IDCITA: this.idcita, PAGINA: i }));
    }
    Promise.all(promesas).then((resultados: any[]) => {
      let todos = [];
      resultados.forEach(res => { if (res.rows) todos = todos.concat(res.rows); });
      const data = todos.map(r => ({
        'Tipo': r.tipo || '', 'Orden': r.orden || '', 'Tipología': r.tipologia || '',
        'Subtipología': r.subtipologia || '', 'Fecha Creación': this.formatFecha(r.fecha),
        'Fecha Visita': r.fecha_visita || '', 'AM/PM': r.am_pm || '',
        'Hora Puntual': r.hora_puntual || '',
        'Estado': r.estado || '', 'Comentario': r.comentario || '', 'Contrata': r.contrata || '',
        'Técnico': r.tecnico || '', 'Usuario': r.usuario || '', 'Prioridad': r.prioridad || '',
        'Dirección': r.direccion || '', 'Localización': r.localizacion || ''
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Histórico');
      const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const orden = todos.length > 0 ? todos[0].orden || '' : '';
      saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Historico_${orden}.xlsx`);
    });
  }

  isCoords(val: string): boolean {
    if (!val) return false;
    return /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(val.trim());
  }

  getMapsUrl(coords: string): string {
    const c = coords.trim();
    return `https://www.google.com/maps?q=${c}`;
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
